export default __webpack_public_path__ + "static/media/capsule_machine.a42c39fa.riv";